import { useContext } from 'react';

import { isDefined } from '@hsp/utilities';

import { SaveContext } from 'pages/audience/shared/save/context/save.context';

export const useSaveStoreSet = () => {
  const store = useContext(SaveContext);

  if (!isDefined(store)) {
    throw new Error('Store not found');
  }

  return store.set;
};
